/**
 * Get a promise that will be resolved in "timeout" ms
 * @param timeout timeout in milliseconds.
 */
export function promiseTimeout(timeout: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, timeout));
}
